<template>   
  {{ currency !== 'USD' ? $currencyFormat(convertCurrency, currency?.toUpperCase()) : $currencyFormat(value, currency?.toUpperCase()) }}
</template>

<script setup>
import { ref, computed } from 'vue'
import { useCurrencyStore } from '@/stores/currency'
import { convertValue } from '@/lib/currency/convertCurrency'
const props = defineProps({
  value: {
    type: Number,
    required: true
  },
  currency: {
    type: String,
    required: true
  }
})
const currencyStore = useCurrencyStore()
const convertCurrency = computed(() => {
  const result = convertValue({
    amount: props.value,
    fromCurrency: 'USD',
    toCurrency: props.currency?.toUpperCase() || 'COP',
    currencyValues: currencyStore.currencyValues,
    isLogger: false
  })
  return result?.value
})
</script>
